/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TherapyEndReasonEnum = {
    RegularEnd: 'REGULAR_END',
    NoInclusionDiagnosis140A: 'NO_INCLUSION_DIAGNOSIS_140A',
    Contraindication140A: 'CONTRAINDICATION_140A',
    AlreadyInGkvTherapy140A: 'ALREADY_IN_GKV_THERAPY_140A',
    NoClearConcern: 'NO_CLEAR_CONCERN',
    ContraindicationSetting: 'CONTRAINDICATION_SETTING',
    LackOfMotivation: 'LACK_OF_MOTIVATION',
    TherapistSideMismatch: 'THERAPIST_SIDE_MISMATCH',
    PatientSideMismatch: 'PATIENT_SIDE_MISMATCH',
    SchedulingMismatch: 'SCHEDULING_MISMATCH',
    LanguageMismatch: 'LANGUAGE_MISMATCH',
    NoConsultationReport: 'NO_CONSULTATION_REPORT',
    MedicationOnly: 'MEDICATION_ONLY',
    ReportOrSickNoteWanted: 'REPORT_OR_SICK_NOTE_WANTED',
    GkvTherapyPlaceFound: 'GKV_THERAPY_PLACE_FOUND',
    FinancialReasons: 'FINANCIAL_REASONS',
    GkvCoverageMisunderstanding: 'GKV_COVERAGE_MISUNDERSTANDING',
    TreatmentBreak: 'TREATMENT_BREAK',
    DropoutReasonUnclear: 'DROPOUT_REASON_UNCLEAR',
    Other: 'OTHER'
} as const;
export type TherapyEndReasonEnum = typeof TherapyEndReasonEnum[keyof typeof TherapyEndReasonEnum];

